import { CrudService, httpClient, type HttpClient } from '../core'
import { accountRelationshipsEndpoints } from './account-relationships.endpoints'
import {
  accountRelationshipPageSchema,
  accountRelationshipSchema,
  type AccountRelationshipCreateBody,
  type AccountRelationshipDto,
  type AccountRelationshipFilters,
  type AccountRelationshipUpdateBody,
} from './account-relationships.schemas'

export class AccountRelationshipsService extends CrudService<AccountRelationshipDto, AccountRelationshipCreateBody, AccountRelationshipUpdateBody, AccountRelationshipFilters> {
  constructor(http: HttpClient = httpClient) {
    super(http, accountRelationshipsEndpoints, { item: accountRelationshipSchema, page: accountRelationshipPageSchema })
  }
}

export const accountRelationshipsService = new AccountRelationshipsService()
